// extracted by mini-css-extract-plugin
export default {"wrapper":"Gaa","container":"Haa","title":"Iaa","desc":"Jaa","usage":"Kaa","box":"Laa","subtitle":"Maa","ingredients":"Naa","carousel":"Oaa","ingredientscarousel":"Paa","productinfo":"Qaa","ingredientsinfo":"Raa"};
    if(module.hot) {
      // 1715632479635
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  